import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MusicFileIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="32" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="28" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="24" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="16" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="12" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="40" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="32" y="4" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="4" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="8" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="12" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="16" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="20" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="24" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="28" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="32" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="36" y="36" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="12" y="8" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="12" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="12" y="14" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="14" y="14" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="16" y="14" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="18" y="14" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="18" y="12" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="18" y="10" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="18" y="8" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="26" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="16" y="28" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="18" y="28" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="30" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="32" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="18" y="34" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="16" y="34" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="14" y="32" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="14" y="30" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="26" y="24" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="28" y="24" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="30" y="26" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="30" y="28" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="28" y="30" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="26" y="30" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="24" y="28" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="24" y="26" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="24" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="22" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="30" y="22" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="28" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="30" y="24" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="30" y="20" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="30" y="18" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="20" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="22" y="20" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="24" y="18" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="26" y="18" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="28" y="16" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="30" y="16" width="2" height="2" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="16" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="20" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="24" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="28" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="32" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="8" y="36" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="28" y="4" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="24" y="4" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="20" y="4" width="4" height="4" fill={fillColor || '#E0E4E4'} />
      <rect x="16" y="4" width="4" height="4" fill={fillColor || '#E0E4E4'} />
    </svg>
  );
};

export { MusicFileIcon };
